import { render, staticRenderFns } from "./mlItemMore.vue?vue&type=template&id=3925815c&lang=pug&"
import script from "./mlItemMore.vue?vue&type=script&lang=js&"
export * from "./mlItemMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports